<template>
    <component
        :is="tag"
        v-bind="tagProps"
        :class="[
            'flex items-center gap-3 px-4 py-3 text-sm transition-colors',
            isActive
                ? 'bg-theme-primary text-theme-inverse'
                : 'text-theme-base hover:bg-theme-hover'
        ]"
    >
        <span v-if="$slots.icon" class="flex-shrink-0">
            <slot name="icon"></slot>
        </span>
        <span class="flex-1 truncate">
            <slot></slot>
        </span>
    </component>
</template>

<script>
export default {
    name: "SidebarItem",
    props: {
        to: { type: String, default: null },
        href: { type: String, default: null }
    },
    computed: {
        tag() {
            if (this.to) return "router-link";
            if (this.href) return "a";
            return "div";
        },
        tagProps() {
            if (this.to) return { to: this.to };
            if (this.href) return { href: this.href, target: "_blank" };
            return {};
        },
        isActive() {
            if (!this.to) return false;
            const path = this.$route.path;
            return path === this.to;
        }
    }
};
</script>
